import styled from 'styled-components';

export const Divider = styled.hr`
  border: 0;
  border-top: 1px solid #e5e7eb;
  margin: 1.5rem 0;
`;